import { render } from "./EmailValidationMessage.vue?vue&type=template&id=479f7f23"
import script from "./EmailValidationMessage.vue?vue&type=script&lang=js"
export * from "./EmailValidationMessage.vue?vue&type=script&lang=js"

import "./EmailValidationMessage.vue?vue&type=style&index=0&id=479f7f23&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__